var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading
    ? _c(
        "div",
        { staticClass: "loading-indicator loading-indicator--full-page" },
        [
          _c("MoonLoader", { attrs: { size: "75px", color: "#ffffff" } }),
          _vm._v(" "),
          _c("div", { staticClass: "loadingText" }, [_vm._v("Loading")])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }